import { useState, useEffect } from "react";
import "./doctor/styles/profilestyle.css";
import api, { showAlert } from "./util/api";
import Navbar from "./header";
import Footer from "./footer";

export default function PaymentDetails() {
    const [banks, setBanks] = useState([]);
    const [submitting, setSubmitting] = useState(false);
    const [progress, setProgress] = useState(0);
    const [showPasswordModal, setShowPasswordModal] = useState(false);
    const [password, setPassword] = useState("");

    const [formData, setFormData] = useState({
        bankName: "",
        bankCode: "",
        accountNumber: "",
        accountName: "",
        coinType: "",
        crypto_address: "",
    });

    // ✅ FETCH EXISTING DATA
    useEffect(() => {
        fetchPaymentDetails();
        fetchBanks();
    }, []);

    const fetchBanks = async () => {
        try {
            const res = await api.get("/banks");
            if (res.data.status === "success") {
                setBanks(res.data.data);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const fetchPaymentDetails = async () => {
        try {
            const res = await api.get("/consultant/payment-details");
            if (res.data.status === "success") {
                setFormData(res.data.data);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "bankName") {
            const selectedBank = banks.find(bank => bank.name === value);
            
            setFormData({
                ...formData,
                bankName: value,
                bankCode: selectedBank ? selectedBank.code : ""
            });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };



    // STEP 1: open password modal
    const handleSubmit = (e) => {
        e.preventDefault();
        setShowPasswordModal(true);
    };

    // STEP 2: submit after password confirmation
    const confirmAndSubmit = async () => {
        if (!password) {
            showAlert("error", "Error", "Password is required");
            return;
        }

        setSubmitting(true);
        setProgress(10);

        const payload = new FormData();
        for (let key in formData) {
            payload.append(key, formData[key]);
        }
        payload.append("password", password);

        try {
            const res = await api.post("/payment_update", payload, {
                headers: { "Content-Type": "multipart/form-data" },
                onUploadProgress: (e) =>
                    setProgress(Math.round((e.loaded / e.total) * 100)),
            });

            if (res.data.status === "success") {
                showAlert("success", "Success", res.data.message);
                fetchPaymentDetails(); // refresh data
                setShowPasswordModal(false);
                setPassword("");
            } else {
                showAlert("error", "Error", res.data.message);
            }
        } catch (err) {
            showAlert("error", "Error", err.message);
        } finally {
            setSubmitting(false);
            setTimeout(() => setProgress(0), 1500);
        }
    };

    return (
        <>
            <Navbar menuColor="black" />

            <section className="payment-section">
                <div className="payment-card">

                    <h2 className="payment-title">Payment Information</h2>

                    <form onSubmit={handleSubmit}>

                        <div className="form-grid">
                            <div>
                                <label>Select Bank</label>
                                <select
                                    name="bankName"
                                    value={formData.bankName}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Bank</option>
                                    {banks.map((bank, index) => (
                                        <option key={index} value={bank.name}>
                                            {bank.name}
                                        </option>
                                    ))}


                                </select>


                                <input   type="hidden" name="bankCode" value={formData.bankCode}  />


                               
                            </div>

                            <div>
                                <label>Account Name</label>
                                <input
                                    name="accountName"
                                    value={formData.accountName}
                                    onChange={handleChange}
                                    placeholder="Account Name"
                                />
                            </div>

                            <div>
                                <label>Account Number</label>
                                <input
                                    name="accountNumber"
                                    value={formData.accountNumber}
                                    onChange={handleChange}
                                    placeholder="Account Number"
                                />
                            </div>

                            <div>
                                <label>Coin Type (Optional)</label>
                                <select
                                    name="coinType"
                                    value={formData.coinType}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Crypto</option>
                                    <option>BTC</option>
                                    <option>USDT</option>
                                    <option>ETH</option>
                                </select>
                            </div>

                            <div className="full-width">
                                <label>Crypto Address (Optional)</label>
                                <input
                                    name="crypto_address"
                                    value={formData.crypto_address}
                                    onChange={handleChange}
                                    placeholder="Crypto Address"
                                />
                            </div>
                        </div>

                        {submitting && (
                            <div className="progress">
                                <div
                                    className="progress-bar"
                                    style={{ width: `${progress}%` }}
                                ></div>
                                <p>{progress}%</p>
                            </div>
                        )}

                        <button
                            type="submit"
                            disabled={submitting}
                            className="submit-btn"
                        >
                            {submitting ? "Submitting..." : "Save Payment Details"}
                        </button>
                    </form>
                </div>
            </section>

            {/* PASSWORD MODAL */}
            {showPasswordModal && (
                <div className="modal-overlay">
                    <div className="modal-box">
                        <h4>Confirm Password</h4>
                        <input
                            type="password"
                            placeholder="Enter your password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <div className="modal-actions">
                            <button style={{ backgroundColor: "#f44336", color: "white" }} onClick={() => setShowPasswordModal(false)}>
                                Cancel
                            </button>
                            <button style={{ backgroundColor: "#4caf50", color: "white" }} onClick={confirmAndSubmit}>
                                Confirm
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <Footer />
        </>
    );
}